import { render, staticRenderFns } from "./FacHeader.vue?vue&type=template&id=6fa65446&scoped=true&"
import script from "./FacHeader.vue?vue&type=script&lang=js&"
export * from "./FacHeader.vue?vue&type=script&lang=js&"
import style0 from "./FacHeader.vue?vue&type=style&index=0&id=6fa65446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa65446",
  null
  
)

export default component.exports